/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { PlaylistCardShort } from '../../models';
import { Page as Pagination } from '../../models/page';
import { ObservableResult } from '../../store';
import { RestClientService } from '../rest-client.service';
import { HelpCenterDataService } from './help-center-data.service';

@Injectable()
export class ApiHelpCenterDataService implements HelpCenterDataService {
  constructor(
    private client: RestClientService,
    private translocoService: TranslocoService,
  ) {}

  getHelpCenter(page: number, size: number): ObservableResult<Pagination<PlaylistCardShort>> {
    const params = {
      page: page.toString(),
      size: size.toString(),
    };
    return this.client
      .get<Pagination<PlaylistCardShort>>(Location.joinWithSlash(environment.apiRootUrl || '', '/help-center'), params)
      .pipe(
        switchMap(({ body }) => ObservableResult.ofSuccess(body)),
        catchError(() => ObservableResult.ofError(this.translocoService?.translate('translations.errors.errorLoadingHelpCenterData'))),
      );
  }

  getHelpCenterTopics(page: number, size: number, tagId?: string, term?: string): ObservableResult<Pagination<PlaylistCardShort>> {
    const params = {
      page: page.toString(),
      size: size.toString(),
      topics: tagId,
    };
    if (tagId && term) {
      params['term'] = term;
    }
    return this.client
      .get<Pagination<PlaylistCardShort>>(Location.joinWithSlash(environment.apiRootUrl || '', '/help-center/for'), params)
      .pipe(
        switchMap(({ body }) => ObservableResult.ofSuccess(body)),
        catchError(() => ObservableResult.ofError(this.translocoService?.translate('translations.errors.errorLoadingHelpCenterData'))),
      );
  }
}
